import React from "react";
import { Link } from "react-router-dom";
import "./styles/PolicyPages.css";

const TermsOfService = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>Terms of Service</h1>
        <p className="policy-updated">Last updated: March 2026</p>

        <section className="policy-section">
          <h2>Acceptance of Terms</h2>
          <p>By accessing or using VyralNews ("the Service"), operated by Vyral Media Group, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our Service. These terms apply to all visitors, users, and others who access or use the Service.</p>
        </section>

        <section className="policy-section">
          <h2>Description of Service</h2>
          <p>VyralNews is an online news platform that provides access to news articles across multiple categories including Politics, World, Business, Health, Technology, Entertainment, Sports, and Local news. We offer both free (freemium) and paid subscription tiers with varying levels of content access.</p>
        </section>

        <section className="policy-section">
          <h2>Accounts</h2>
          <p>To access certain features, you must create an account. You are responsible for:</p>
          <ul>
            <li>Maintaining the confidentiality of your login credentials</li>
            <li>All activity that occurs under your account</li>
            <li>Notifying us immediately of any unauthorized use of your account</li>
            <li>Ensuring that your account information is accurate and up to date</li>
          </ul>
          <p>We reserve the right to suspend or terminate accounts that violate these terms.</p>
        </section>

        <section className="policy-section">
          <h2>Subscription Plans and Payments</h2>
          <p>VyralNews offers the following subscription options:</p>
          <ul>
            <li><strong>Free (Freemium)</strong> – Limited access to 10 articles per week</li>
            <li><strong>Monthly Plan</strong> – Full access billed monthly</li>
            <li><strong>3-Month Plan</strong> – Full access billed every three months</li>
            <li><strong>Yearly Plan</strong> – Full access billed annually</li>
          </ul>
          <p>Subscriptions automatically renew unless canceled before the renewal date. By subscribing, you authorize us to charge your payment method on a recurring basis. All payments are processed securely through Stripe. See our <Link to="/payment-policy">Payment Policy</Link> for full details.</p>
        </section>

        <section className="policy-section">
          <h2>Cancellation and Refunds</h2>
          <p>You may cancel your subscription at any time from your <Link to="/user/profile">Profile page</Link>. Upon cancellation, you retain access to premium content until the end of your current billing period. We do not offer refunds for partial billing periods. See our <Link to="/refund-policy">Refund Policy</Link> for full details.</p>
        </section>

        <section className="policy-section">
          <h2>Content and Intellectual Property</h2>
          <p>All content published on VyralNews, including articles, images, graphics, logos, and other materials, is the property of Vyral Media Group or its content contributors and is protected by copyright and intellectual property laws. You may not:</p>
          <ul>
            <li>Reproduce, distribute, or republish our content without written permission</li>
            <li>Scrape or systematically download articles or data from our platform</li>
            <li>Use our content for commercial purposes without authorization</li>
            <li>Remove or alter any copyright or proprietary notices</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>Acceptable Use</h2>
          <p>You agree not to use the Service to:</p>
          <ul>
            <li>Violate any applicable laws or regulations</li>
            <li>Attempt to gain unauthorized access to our systems or other users' accounts</li>
            <li>Transmit spam, malware, or any harmful code</li>
            <li>Interfere with or disrupt the integrity or performance of the Service</li>
            <li>Circumvent any access controls or freemium limitations</li>
            <li>Impersonate any person or entity</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>Premium Content</h2>
          <p>Certain articles on VyralNews are designated as Premium content. Access to Premium articles requires an active paid subscription. Freemium users and non-registered visitors will see only a brief excerpt of Premium articles. We reserve the right to designate any article as Premium at our discretion.</p>
        </section>

        <section className="policy-section">
          <h2>Disclaimer of Warranties</h2>
          <p>The Service is provided on an "as is" and "as available" basis without warranties of any kind, either express or implied. We do not warrant that the Service will be uninterrupted, error-free, or free of viruses or other harmful components. News content is provided for informational purposes only and does not constitute professional advice.</p>
        </section>

        <section className="policy-section">
          <h2>Limitation of Liability</h2>
          <p>To the fullest extent permitted by law, Vyral Media Group shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of, or inability to use, the Service. Our total liability to you shall not exceed the amount you paid to us in the 12 months prior to the claim.</p>
        </section>

        <section className="policy-section">
          <h2>Changes to the Service and Terms</h2>
          <p>We reserve the right to modify or discontinue the Service at any time without notice. We may also update these Terms of Service. We will notify users of significant changes by updating the "Last updated" date. Continued use of the Service after changes constitutes your acceptance of the new terms.</p>
        </section>

        <section className="policy-section">
          <h2>Governing Law</h2>
          <p>These Terms of Service shall be governed by and construed in accordance with the laws of the State of New Jersey, United States, without regard to its conflict of law provisions.</p>
        </section>

        <section className="policy-section">
          <h2>Contact Us</h2>
          <p>If you have questions about these Terms of Service, please contact us at:<br />
          <a href="mailto:info@vyralmediagroup.com">info@vyralmediagroup.com</a><br />
          Vyral Media Group</p>
        </section>

        <div className="policy-links">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/payment-policy">Payment Policy</Link>
          <Link to="/refund-policy">Refund Policy</Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
